import React from 'react';
import { useIntl } from 'react-intl';
import { MusicService } from 'fym-shared/src/music-services/types';
import { TypedMemo } from '../../common/types';
import { musicServiceImagesByImporterId } from '../../common/musicServiceImages';
import styles from './SMLPublishedRoutes.module.scss';

interface SMLPublishedRoutesProps {
  /** The services the page routes to, in page order. */
  services: MusicService[];
  onEdit: () => void;
}

/**
 * Where a release page sends people.
 *
 * The marks are the services the page's own link blocks carry, in the order
 * fans see them, so the strip answers the one question worth asking about a
 * live release page: is everything on it?
 */
const SMLPublishedRoutesComponent: React.FC<SMLPublishedRoutesProps> = ({ services, onEdit }) => {
  const intl = useIntl();

  return (
    <div className={styles.strip}>
      <span className={styles.label}>
        {intl.formatMessage({ id: 'app.sml.published.routes', defaultMessage: 'Routes to' })}
      </span>
      <span className={styles.marks}>
        {services.map((service) => {
          const images =
            service.importerID === undefined ? undefined : musicServiceImagesByImporterId[service.importerID];
          const Logo = images?.logoColor.dark;
          return (
            <span key={service.id} className={styles.mark} title={service.name}>
              {Logo === undefined ? (
                <i className={styles.dot} style={{ background: service.color.primary }} />
              ) : (
                <Logo width={18} height={18} />
              )}
            </span>
          );
        })}
      </span>
      <button type="button" className={styles.edit} onClick={onEdit}>
        {intl.formatMessage({ id: 'app.sml.published.routes.edit', defaultMessage: 'Edit' })}
      </button>
    </div>
  );
};

export const SMLPublishedRoutes = TypedMemo(SMLPublishedRoutesComponent);
